import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage.tsx';
import type { ActionButtonProps } from '@openx/components-header/HeaderActions/ActionButton.tsx';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../components/AuthContext/context.ts';
import { isAdmin } from '../../permissions/validators.ts';
import { ProvidersList } from './ProvidersList/ProvidersList.tsx';

export const ProvidersListPage = () => {
  const { session } = useAuth();
  const { t } = useTranslation();
  const isAllowed = isAdmin(session);

  const actions: Array<ActionButtonProps> = [
    {
      color: 'primary',
      'data-test': 'create-provider-button',
      href: '/providers/create',
      label: t('Create New Provider'),
      showAsActionButton: true,
    },
  ];

  if (!isAllowed) return <AccessForbiddenPage />;

  return (
    <PageHeader
      render={() => <HeaderActions actions={actions} />}
      titlePrefix="OpenXSelect"
      title={t('Providers List')}
      sticky
    >
      <ProvidersList />
    </PageHeader>
  );
};
